<template>
  <v-container fluid class="pb-0">
    <v-layout class="visits-search-bar">
      <v-flex md="12" class="pb-2 mxw-400 d-flex">
        <div
          class="text-uppercase text-h5 font-weight-bold color-custom-blue mr-3"
          v-if="!contractId"
        >
          Recurring Jobs
        </div>
        <v-text-field
          class="mxw-200"
          v-model.trim="filter_search"
          v-on:click:clear="clearFilter('search')"
          clearable
          dense
          filled
          flat
          label="Type and press enter to search"
          hide-details
          solo
          :loading="pageLoading"
          :disabled="pageLoading"
          color="cyan"
          append-icon="mdi-magnify"
          @keydown.enter="filterRow()"
          @keydown.tab="filterRow()"
          v-on:change="filterRow()"
        ></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <div class="pr-0 pb-2 d-flex">
        <v-tooltip
          v-if="
            !internal &&
            this.detailType != 'tickets' &&
            getPermission('visit:create')
          "
          top
          content-class="custom-top-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2 custom-btn-color white--text"
              tile
              depressed
              :disabled="pageLoading"
              v-on:click="createJob()"
            >
              <v-icon>mdi-plus</v-icon>
              Create Visit
            </v-btn>
          </template>
          <span>Create Visit</span>
        </v-tooltip>
        <!-- {{ $route.query.tab }} -->

        <v-btn
          v-if="!internal && this.detailType != 'tickets'"
          tile
          depressed
          :disabled="pageLoading"
          :type-id="$route.query.tab"
          class="mx-2 custom-bold-button"
          v-on:click="exportVisit"
          color="cyan white--text"
        >
          <v-icon dark>mdi-database-export</v-icon>
        </v-btn>
        <v-btn
          v-if="!internal"
          tile
          depressed
          :disabled="pageLoading"
          :type-id="$route.query.tab"
          class="mx-2 custom-bold-button"
          v-on:click="openFilter"
          color="cyan white--text"
        >
          <v-icon dark>mdi-filter</v-icon>
        </v-btn>
        <v-menu
          v-if="!internal && this.detailType != 'tickets'"
          max-height="400"
          max-width="250"
          offset-y
          left
          :close-on-content-click="false"
          content-class="white-background"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              :disabled="pageLoading"
              class="mx-1 custom-bold-button btn-tab-hide"
              color="cyan white--text"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-table-edit</v-icon>
            </v-btn>
          </template>
          <draggable
            tag="ul"
            v-on:change="updateVisible()"
            v-model="defaultColDefs"
            class="draggable-group"
            handle=".draggable-drag-icon"
          >
            <template v-for="cols in defaultColDefs">
              <li
                class="draggable-group-item"
                :key="cols.field"
                v-if="!cols.checkbox || Number(cols.checkbox) == 0"
              >
                <v-checkbox
                  dense
                  v-model="defaultColShow"
                  v-bind:value="cols.field"
                  :label="cols.headerName"
                  :disabled="Number(cols.fixed) || pageLoading"
                  color="cyan"
                  hide-details
                  class="mt-0 mb-0"
                  v-on:change="updateVisible()"
                ></v-checkbox>
                <v-icon class="draggable-drag-icon" right color="cyan"
                  >mdi-drag</v-icon
                >
              </li>
            </template>
          </draggable>
        </v-menu>
      </div>
    </v-layout>

    <perfect-scrollbar
      :options="{ suppressScrollX: true }"
      class="scroll custom-box-top-inner-shadow"
    >
      <!-- <pre>{{defaultColDefs  columnLength()}}</pre> -->
      <ListingTable
        :columnCount="columnLength() || 8"
        :pageLoading="pageLoading"
        :rowData="rowData"
      >
        <template v-slot:thead>
          <thead>
            <tr>
              <template v-for="cols in customThead">
                <th
                  v-if="cols.visible"
                  :key="cols.id"
                  class="simple-table-th"
                  :class="{
                    'checkbox-width-limit': cols.checkbox,
                    'pointer-events-none': lodash.isEmpty(rowData),
                  }"
                >
                  <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                    <v-checkbox
                      dense
                      :disabled="pageLoading"
                      color="cyan"
                      class="hide-margin"
                      hide-details
                    ></v-checkbox>
                  </template>
                  <template v-else>
                    <div
                      v-if="cols.sortable"
                      class="simple-table-text sortable"
                      v-on:click="
                        !pageLoading
                          ? updateSorting({
                              field: cols.field,
                              sort: cols.sort,
                            })
                          : 'javascript:void(0)'
                      "
                    >
                      {{ cols.headerName }}
                    </div>
                    <div v-else class="simple-table-text">
                      {{ cols.headerName }}
                    </div>

                    <template v-if="cols.sort">
                      <v-icon
                        class="simple-table-sort"
                        v-if="cols.sort == 'asc'"
                        small
                        right
                        color="cyan"
                        >mdi-sort-ascending</v-icon
                      >
                      <v-icon
                        class="simple-table-sort"
                        v-if="cols.sort == 'desc'"
                        small
                        right
                        color="cyan"
                        >mdi-sort-descending</v-icon
                      >
                    </template>
                  </template>
                </th>
              </template>
            </tr>
          </thead>
        </template>
        <template v-slot:tbody>
          <tbody class="custom-border-bottom">
            <template v-if="pageLoading">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="3" align="center">
                  <p class="font-size-20 font-weight-600 my-4">
                    Please wait...
                  </p>
                  <v-progress-linear
                    color="cyan"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                  <br />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <template v-if="!lodash.isEmpty(rowData)">
              <tr
                v-for="(row, index) in rowData"
                :key="index"
                link
                class="customer-listing-row"
                v-on:click="
                  $router.push(
                    getDefaultRoute(detailRoute, {
                      params: { id: row.visit_id },
                      query: {
                        ...routeQuery,
                      },
                    })
                  )
                "
              >
                <template v-for="cols in customThead">
                  <td
                    v-if="cols.visible"
                    :key="cols.id"
                    class="font-size-18 font-weight-500"
                    :class="{
                      'simple-table-td': !cols.checkbox,
                      'checkbox-width-limit': cols.checkbox,
                    }"
                  >
                    <template
                      v-if="cols.checkbox && Number(cols.checkbox) == 1"
                    >
                      <v-checkbox
                        dense
                        v-model="selectedRows"
                        v-bind:value="Number(row.id)"
                        color="cyan"
                        class="hide-margin"
                        hide-details
                      ></v-checkbox>
                    </template>
                    <template v-else-if="cols.field == 'related_id'">
                      <template
                        v-if="
                          row.quotation_barcode ||
                          row.preventive_barcode ||
                          row.enquiries_barcode
                        "
                      >
                        <div class="mt-0 mb-1">
                          <v-chip
                            small
                            v-if="row.quotation_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="cyan"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.quotation_id,
                                'admin.quotation.detail'
                              )
                            "
                          >
                            {{ row.quotation_barcode }}
                          </v-chip>
                        </div>
                        <div class="my-0">
                          <v-chip
                            small
                            v-if="row.enquiries_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="orange"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.enquiries_id,
                                'admin.enquiry.detail'
                              )
                            "
                          >
                            {{ row.enquiries_barcode }}
                          </v-chip>
                        </div>
                      </template>
                      <template v-else> --</template>
                    </template>
                    <template v-else-if="cols.field == 'parent_id'">
                      <template v-if="row.ticket_barcode">
                        <div class="mt-0 mb-1">
                          <v-chip
                            small
                            v-if="row.ticket_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="cyan"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.visit_id,
                                'admin.recurring-job.detail'
                              )
                            "
                          >
                            {{ row.ticket_barcode }}
                          </v-chip>
                        </div>
                      </template>
                      <template v-else> --</template>
                    </template>
                    <template v-else-if="cols.field == 'barcode'">
                      <div class="d-flex mb-1">
                        <v-chip
                          label
                          dense
                          small
                          color="chip-custom-blue"
                          outlined
                          class="font-weight-600 custom-barcode"
                        >
                          <template v-if="row.trip_barcode">{{
                            row.trip_barcode
                          }}</template>
                          <template v-else>--</template>
                        </v-chip>
                        <v-tooltip
                          v-if="
                            row.ticket_job_type == 2 && row.recurring_count > 0
                          "
                          top
                          content-class="custom-top-tooltip"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              v-if="
                                row.ticket_job_type == 2 &&
                                row.recurring_count > 0
                              "
                              small
                              class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10 ml-1"
                              color="chip-custom-blue"
                              label
                              outlined
                            >
                              <span style="color: red">{{
                                row.recurring_count
                              }}</span>
                              /
                              <span style="color: green">{{
                                row.visit_count
                              }}</span>
                            </v-chip>
                          </template>
                          <span>No of Recurring / Total Schedule</span>
                        </v-tooltip>
                      </div>

                      <div class="my-0">
                        <v-chip
                          small
                          class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10"
                          color="chip-custom-blue"
                          label
                          outlined
                        >
                          <template
                            v-if="row.ticket_job_type_text == 'One-Off Job'"
                          >
                            Adhoc job</template
                          >
                          <template v-else>
                            {{ row.ticket_job_type_text }}</template
                          >
                        </v-chip>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'visit_title'">
                      <div class="job-listing-customer">
                        <p
                          class="m-0 custom-nowrap-ellipsis-two-line"
                          style="width: 200px"
                        >
                          {{ row.visit_title }}
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'property'">
                      <div class="job-listing-customer">
                        <p
                          class="m-0 custom-nowrap-ellipsis-two-line"
                          v-if="row.property_address"
                          style="width: 300px"
                        >
                          <span
                            content="Site Location"
                            class="d-flex"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b>
                              <v-icon style="font-size: 18px; margin-top: -3px">
                                mdi-home-map-marker
                              </v-icon>
                            </b>
                            <template v-if="row?.property_name"
                              >{{ row?.property_name }},</template
                            >
                            <template v-if="row?.property_unit_no"
                              >{{ row?.property_unit_no }},</template
                            >
                            <template v-if="row?.property_street_1"
                              >{{ row?.property_street_1 }},</template
                            >
                            {{ row?.property_street_2 }}

                            {{ row?.property_country }}
                            <template
                              v-if="
                                row?.property_zip_code &&
                                row?.property_zip_code != '000000'
                              "
                            >
                              {{ row?.property_zip_code }}
                            </template>
                          </span>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'customer_company'">
                      <div class="job-listing-customer" style="width: 220px">
                        <p class="m-0">
                          <v-chip
                            label
                            small
                            color="green white--text"
                            class="d-inline mx-2"
                            v-if="row.is_property_tenant"
                            >Tenant</v-chip
                          >
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0"
                            style="
                              display: inline-block;
                              max-width: 200px;
                              white-space: normal;
                              word-break: break-word;
                            "
                            content="Company Name"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b
                              ><v-icon style="font-size: 16px"
                                >mdi-bag-checked</v-icon
                              ></b
                            >
                            {{ row.customer_company_name }}
                          </span>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'customer'">
                      <div class="job-listing-customer">
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Site Location Contact Person Email"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b>
                              <v-icon style="font-size: 16px">
                                mdi-email
                              </v-icon>
                            </b>
                            <template v-if="row && row.property_primary_email">
                              {{ row.property_primary_email }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no email</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Site Location Contact Person Phone"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b>
                              <v-icon style="font-size: 16px">
                                mdi-phone
                              </v-icon>
                            </b>
                            <template v-if="row && row.property_primary_phone">
                              {{ row.property_primary_phone }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no phone</em>
                            </template>
                          </span>
                        </p>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'project'">
                      <div
                        class="job-listing-customer"
                        v-if="row && row.project_barcode"
                      >
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Project #"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Project # : </b>
                            <template v-if="row && row.project_barcode">
                              {{ row.project_barcode }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no name</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Project Name"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Name : </b>
                            <template v-if="row && row.project_name">
                              {{ row.project_name }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no name</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Project Start Date"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Start : </b>
                            <template v-if="row && row.project_started">
                              {{ formatDate(row.project_started) }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no start date</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Project End Date"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> End : </b>
                            <template v-if="row && row.project_deadline">
                              {{ formatDate(row.project_deadline) }}
                            </template>
                            <template v-else>
                              <em class="text-muted"> no end date</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Project Milestones"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Milestones : </b>
                            <template v-if="row && row.project_milestones">
                              <template
                                v-if="
                                  row &&
                                  row.project_milestones &&
                                  row.project_milestones[0] &&
                                  row.project_milestones[0].name
                                "
                              >
                                {{ row.project_milestones[0].name }}
                              </template>
                              <template v-if="row.project_milestones_count > 1">
                                <v-chip
                                  small
                                  color="blue white--text"
                                  label
                                  class="ml-2"
                                >
                                  <span class="font-size-16 font-weight-500">
                                    +{{
                                      row.project_milestones_count - 1
                                    }}
                                    More</span
                                  >
                                </v-chip>
                              </template>
                            </template>
                            <template v-else>
                              <em class="text-muted"> no milestone</em>
                            </template>
                          </span>
                        </p>
                      </div>
                      <em v-else class="text-muted"> no project details</em>
                    </template>
                    <template v-else-if="cols.field == 'tags'">
                      <div style="width: 150px">
                        <template v-if="row.tags && row.tags.length">
                          <template v-for="(data, index) in row.tags">
                            <v-chip
                              :key="index"
                              v-if="index < 3"
                              style="height: 18px"
                              class="mr-2 mb-1"
                              text-color="white"
                              :color="data.color"
                              >{{ data.tag }}</v-chip
                            >
                          </template>
                          <template v-if="row.tags.length > 3">
                            <v-chip
                              small
                              color="blue white--text"
                              label
                              class="ml-2"
                            >
                              <span class="font-size-16 font-weight-500">
                                +{{ row.tags.length - 3 }} More</span
                              >
                            </v-chip>
                          </template>
                        </template>
                        <em v-else class="text-muted"> no tags</em>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'started_at'">
                      <p class="m-0 max-content-width text-truncate">
                        <span class="d-block">
                          {{ formatDate(row.visit_started_at) }}
                          {{ formatDateTimeStart(row.visit_started_at) }}
                          <br />
                          {{ formatDate(row.visit_finished_at) }}
                          {{ formatDateTimeStart(row.visit_finished_at) }}
                        </span>
                        <span v-if="!isDeleted" class="d-block">
                          <v-chip
                            class="mt-0 mb-0 font-weight-600 cursor-pointer text-lowercase"
                            color="chip-custom-blue"
                            small
                            outlined
                            label
                          >
                            <template v-if="row.visit_status === 4">
                              completed in {{ row.visit_duration_human }}
                            </template>
                            <template v-else-if="row.visit_status === 2">
                              in-progress
                            </template>
                            <template v-else>
                              <template v-if="row.visit_overdue === 1"
                                >delayed by
                                {{
                                  calculateTotalDuration(row.visit_started_at)
                                }}</template
                              >
                              <template v-else-if="row.visit_today === 1"
                                >ends in
                                {{
                                  calculateTotalDuration(row.visit_finished_at)
                                }}</template
                              >
                              <template v-else
                                >starts in
                                {{
                                  calculateTotalDuration(row.visit_started_at)
                                }}</template
                              >
                            </template>
                          </v-chip>
                        </span>
                      </p>
                    </template>
                    <template v-else-if="cols.field == 'actual_start_date'">
                      <div
                        class="m-0 max-content-width text-truncate"
                        v-if="row.actual_start_date || row.actual_end_date"
                      >
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Actual Start Date"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Started At : </b>
                            <template v-if="row && row.actual_start_date">
                              <v-chip small outlined color="red" label>
                                {{ formatDate(row.actual_start_date) }}
                                {{ formatDateStartTime(row.actual_start_date) }}
                              </v-chip>
                            </template>
                            <template v-else>
                              <em class="text-muted"> no started at</em>
                            </template>
                          </span>
                        </p>
                        <p class="m-0">
                          <span
                            class="m-0 text-truncate"
                            content="Actual End Date"
                            v-tippy="{
                              arrow: true,
                              arrowType: 'round',
                              animation: 'fade',
                            }"
                          >
                            <b> Ended At &nbsp;&nbsp;: </b>
                            <template v-if="row && row.actual_end_date">
                              <v-chip small outlined color="green" label>
                                {{ formatDate(row.actual_end_date) }}
                                {{ formatDateStartTime(row.actual_end_date) }}
                              </v-chip>
                            </template>
                            <template v-else>
                              <em class="text-muted"> no ended at</em>
                            </template>
                          </span>
                        </p>
                        <v-chip
                          v-if="
                            row &&
                            row.actual_end_date &&
                            row.actual_start_date &&
                            calculateActualTotalDuration(row)
                          "
                          class="mt-2 mb-2 font-weight-600 cursor-pointer text-lowercase"
                          color="chip-custom-blue"
                          small
                          outlined
                          label
                        >
                          Total time {{ calculateActualTotalDuration(row) }}
                        </v-chip>
                      </div>
                      <em v-else class="text-muted"> no actual date / time</em>
                    </template>
                    <template v-else-if="cols.field == 'status'">
                      <!-- <span class="d-flex"> -->
                      <div>
                        <v-chip
                          class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                          :color="getStatusColor(row.visit_status)"
                          label
                          small
                          :text-color="
                            row.visit_status == 2 ? 'black' : 'white'
                          "
                        >
                          {{ row.visit_status_text }}
                        </v-chip>
                      </div>

                      <div>
                        <Priority
                          small
                          :priority="priortyInteger(row.ticket_priority)"
                        ></Priority>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'rating' && false">
                      <div class="custom-nowrap-ellipsis">
                        <template v-if="row.visit_status == 4">
                          <template v-if="row?.rating_status == 3">
                            <v-rating
                              v-if="row.visit_rating_type == 'star'"
                              readonly
                              dense
                              v-model.trim="row.visit_rating_value"
                              background-color="orange lighten-3"
                              color="orange"
                            ></v-rating>
                            <v-rating
                              color=""
                              v-model.trim="row.visit_rating_value"
                              readonly
                              v-if="
                                row.visit_status == 4 &&
                                row.visit_rating_type == 'number'
                              "
                            >
                              <template v-slot:item="props">
                                <v-avatar
                                  class="mx-1"
                                  style="border: 2px solid orange"
                                  :color="
                                    props.isFilled ? 'orange text-white' : ''
                                  "
                                  size="25"
                                >
                                  <span class="text-h6">{{
                                    props.index + 1
                                  }}</span>
                                </v-avatar>
                              </template>
                            </v-rating>
                          </template>
                          <template v-else>
                            <v-chip
                              label
                              :color="getReviewStatusColor(row?.rating_status)"
                              text-color="white"
                              small
                            >
                              {{ row?.rating_status_text }}
                            </v-chip>
                          </template>
                        </template>
                        <template v-else>
                          <em class="text-muted"> no rating</em>
                        </template>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'visit_flag'">
                      <div class="property-listing-customer">
                        <p class="m-1 mb-1 custom-nowrap-ellipsis-count">
                          <b>
                            <v-icon
                              :color="
                                row.is_service_form == 1 ? 'green' : 'red'
                              "
                              size="20"
                              >mdi-form-select</v-icon
                            >
                          </b>
                          <template v-if="row?.serviceFrom?.length > 0">
                            <v-badge
                              :color="
                                row.is_service_form == 1 ? 'green' : 'red'
                              "
                              class="mr-9 ml-5"
                              style="margin-bottom: -2px !important"
                              :content="row?.serviceFrom?.length"
                            >
                            </v-badge>
                          </template>
                          <template v-else>
                            <v-badge
                              :color="
                                row.is_service_form == 1 ? 'green' : 'red'
                              "
                              content="0"
                              class="mr-9 ml-5"
                              style="margin-bottom: -2px !important"
                            >
                            </v-badge>
                          </template>
                        </p>
                      </div>
                      <div class="property-listing-customer">
                        <p class="m-1 mb-1 custom-nowrap-ellipsis-count">
                          <b>
                            <v-icon
                              :disabled="
                                row && row.is_voice_note ? false : true
                              "
                              color="green"
                              >mdi-play-circle</v-icon
                            >
                          </b>
                          <template v-if="row?.audio_count > 0">
                            <v-badge
                              :color="row.is_voice_note ? 'green' : '#9e978a'"
                              class="mr-9 ml-4"
                              style="margin-bottom: -2px !important"
                              :content="row?.audio_count"
                            >
                            </v-badge>
                          </template>
                          <template v-else>
                            <v-badge
                              :color="row.is_voice_note ? 'green' : '#9e978a'"
                              content="0"
                              class="mr-9 ml-4"
                              style="margin-bottom: -2px !important"
                              :disabled="
                                row && row.is_voice_note ? false : true
                              "
                            >
                            </v-badge>
                          </template>
                        </p>
                      </div>

                      <template v-if="row.follow_ups_data == 1">
                        <div class="">
                          <v-chip
                            small
                            label
                            outlined
                            class="mx-2 d-inline justify-center font-10"
                            text-color=""
                            color="green"
                          >
                            Follow Up Open
                          </v-chip>
                        </div>
                      </template>
                      <template v-if="row.follow_ups_data == 2">
                        <div class="my-1">
                          <v-chip
                            small
                            label
                            outlined
                            class="mx-2 d-inline justify-center font-10"
                            text-color=""
                            color="red"
                          >
                            Follow Up Closed
                          </v-chip>
                        </div>
                      </template>
                      <div v-if="row.visit_reschedule_count > 0" class="my-0">
                        <v-chip
                          small
                          class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10"
                          color="red lighten-1"
                          label
                          outlined
                        >
                          Revision ({{ row.visit_reschedule_count }})
                        </v-chip>
                      </div>
                    </template>
                    <template v-else-if="cols.field == 'engineers'">
                      <v-menu
                        v-if="row.visit_engineers && row.visit_engineers.length"
                        top
                        open-on-hover
                        offset-y
                        nudge-top="4"
                        open-delay="100"
                        close-delay="150"
                        min-width="320"
                        max-width="340"
                        content-class="elevation-8"
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="job-listing-customer"
                            style="min-width: 150px; width: 200px; cursor: default"
                          >
                            <p class="m-0 font-weight-700 text-capitalize">
                              {{ row.visit_engineers[0].display_name }}
                            </p>
                            <p class="m-0 text--secondary font-size-14">
                              {{ row.visit_engineers[0].designation_name || "No designation" }}
                            </p>
                            <v-chip
                              v-if="row.visit_engineers.length > 1"
                              small
                              label
                              color="blue white--text"
                              class="mt-1"
                            >
                              +{{ row.visit_engineers.length - 1 }} more
                            </v-chip>
                          </div>
                        </template>

                        <v-card
                          width="340"
                          class="rounded-lg"
                          style="overflow: hidden; cursor: default"
                          v-on:click.stop
                        >
                          <div
                            class="d-flex align-center px-4 py-2"
                            style="background: #fafafa; border-bottom: 1px solid #e0e0e0"
                          >
                            <v-icon size="18" class="mr-2">mdi-account-group-outline</v-icon>
                            <span class="font-weight-700" style="font-size: 14px">Technicians</span>
                            <span
                              class="ml-2 px-2 font-weight-600"
                              style="font-size: 12px; background: #eeeeee; border-radius: 10px; line-height: 20px"
                            >
                              {{ row.visit_engineers.length }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  <v-btn
                                    icon
                                    small
                                    :disabled="isDeleted"
                                    v-on:click.stop="openAssignDialog(row)"
                                  >
                                    <v-icon size="18">mdi-cog-outline</v-icon>
                                  </v-btn>
                                </span>
                              </template>
                              <span>Assign Technicians</span>
                            </v-tooltip>
                          </div>

                          <div style="max-height: 200px; overflow-y: auto">
                            <div v-for="(eng, i) in row.visit_engineers" :key="'e' + eng.id">
                              <div class="d-flex align-start px-4 py-3">
                                <v-avatar size="40" color="grey lighten-3" class="mr-3 flex-shrink-0">
                                  <v-img v-if="eng.profile_logo" :src="eng.profile_logo"></v-img>
                                  <span v-else class="font-weight-600 grey--text text--darken-2">
                                    {{ (eng.display_name || "").slice(0, 2).toUpperCase() }}
                                  </span>
                                </v-avatar>

                                <div style="min-width: 0; flex: 1">
                                  <div
                                    class="font-weight-700 text-capitalize text-truncate"
                                    style="font-size: 15px; line-height: 1.3"
                                  >
                                    {{ eng.display_name }}
                                  </div>
                                  <div
                                    class="text--secondary text-truncate"
                                    style="font-size: 12px; line-height: 1.4"
                                  >
                                    {{ eng.designation_name || "No designation" }}
                                  </div>

                                  <div class="mt-2" style="font-size: 13px">
                                    <div class="d-flex align-center mb-1">
                                      <v-icon size="15" color="cyan" class="mr-2 flex-shrink-0">
                                        mdi-email-outline
                                      </v-icon>
                                      <span
                                        v-if="eng.email"
                                        class="text-truncate"
                                        style="color: inherit; text-decoration: none"
                                        :title="eng.email"
                                      >
                                        {{ eng.email }}
                                      </span>
                                      <span v-else class="text--disabled">Not available</span>
                                    </div>
                                    <div class="d-flex align-center">
                                      <v-icon size="15" color="cyan" class="mr-2 flex-shrink-0">
                                        mdi-phone-outline
                                      </v-icon>
                                      <span
                                        v-if="eng.phone"
                                        style="color: inherit; text-decoration: none"
                                      >
                                        {{ eng.phone }}
                                      </span>
                                      <span v-else class="text--disabled">Not available</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <v-divider
                                v-if="i < row.visit_engineers.length - 1"
                                class="my-0 mx-4"
                              ></v-divider>
                            </div>
                          </div>
                        </v-card>
                      </v-menu>

                      <div v-else class="job-listing-customer d-flex align-center">
                        <em class="text-muted mr-2">no technician assigned</em>
                        <v-tooltip top content-class="custom-top-tooltip" v-if="!isDeleted">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              v-on:click.stop="openAssignDialog(row)"
                              icon
                              small
                              class="flex-shrink-0"
                            >
                              <v-icon size="18">mdi-cog-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Assign Technicians</span>
                        </v-tooltip>
                      </div>

                      <v-chip
                        v-if="
                          row.is_rejeced == 1 &&
                          row.visit_engineers &&
                          row.visit_engineers.length == 0
                        "
                        label
                        color="red"
                        outlined
                        text-color=""
                        class="p-3 mr-5 mb-1"
                        small
                        >Re-assignment Pending
                      </v-chip>
                      <div
                        class=""
                        v-if="row?.enroute == 1 && (row.visit_status == 2 || row.visit_status == 3)"
                      >
                        <v-chip
                          v-if="row?.enroute"
                          small
                          label
                          class="d-inline justify-center font-10 mt-2"
                          text-color="white"
                          color="#2a806b"
                        >
                          Enroute
                        </v-chip>
                      </div>
                    </template>

                    <template v-if="cols.field == 'action'">
                      <!-- <v-tooltip top content-class="custom-top-tooltip" v-if="row.visit_status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              depressed
                              color="deep-orange darken-1 white--text visit-force-close-btn my-auto mr-1"
                              v-on:click.stop="openForceCloseDialog(row)"
                            >
                              <v-icon style="font-size: 18px; line-height: 18px"
                                >mdi-close-octagon-outline</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>Force Close</span>
                        </v-tooltip> -->

                      <v-tooltip
                        top
                        content-class="custom-top-tooltip"
                        v-if="
                          getPermission('visit:delete') && row.visit_status == 1
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="red lighten-1"
                            class="visit-delete-btn my-auto"
                            v-on:click.stop="deleteVisit(row)"
                          >
                            <v-icon style="font-size: 22px; line-height: 20px"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </template>

                    <template v-else-if="cols.field == 'visit_added_at'">
                      <v-chip
                        v-if="row.added_by_display_name"
                        class="mx-2 my-1 custom-grey-border"
                        color="cyan darken-1"
                        small
                        label
                        text-color="white"
                      >
                        <!-- <v-avatar left>
                          <v-icon>mdi-account-circle</v-icon>
                        </v-avatar> -->
                        <p class="m-0 custom-nowrap-ellipsis text-capitalize">
                          {{ row.added_by_display_name }}
                        </p>
                      </v-chip>
                      <TableActivity :data="row">
                        <template v-slot:date_time>
                          <template v-if="getDateCountAll(row.added_at)">{{
                            row.created_at
                          }}</template>
                          <template v-else>{{
                            formatDateTime(row.added_at)
                          }}</template>
                        </template>
                        <template v-slot:format_date_time>
                          {{ formatDate(row.added_at) }}
                          {{ formatTime(row.added_at) }}
                        </template>
                      </TableActivity>
                    </template>
                  </td>
                </template>
              </tr>
            </template>
            <tr v-else-if="!pageLoading">
              <td :colspan="customThead.length" class="py-4">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no visit at the moment.
                </p>
              </td>
            </tr>
          </tbody>
        </template>
      </ListingTable>
    </perfect-scrollbar>
    <ListingFooter
      :dataLoading="pageLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
      :key="uniqueId"
    ></ListingFooter>
    <DeleteDialog :delete-dialog="deleteVisitDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-16 font-weight-500 delete-text">
          Once you delete
          <span class="font-weight-700">{{ deleteVisitBarcode }}</span
          >, you won't be able to retrieve this later.<br />Are you sure you
          want to delete
          <span class="font-weight-700">{{ deleteVisitBarcode }}</span>
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteVisitLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteVisitDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteVisitLoading"
          :loading="deleteVisitLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteVisitConfirm()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>
    <v-navigation-drawer
      v-model="isFilterDrawer"
      absolute
      temporary
      right
      :width="500"
      z-index="200000"
    >
      <v-card text class="main-listing-page" style="block-size: 100%">
        <div class="d-flex flex-column" style="block-size: 100%">
          <v-card-title class="border-bottom-grey">
            <span class="text-uppercase" style="font-size: 16px"
              >Add Filters
            </span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="isFilterDrawer = false">
              <v-icon size="30">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll custom-box-top-inner-shadow flex-grow-1"
          >
            <div class="pa-5">
              <div class="visits-search-bar flex-wrap">
                <v-flex md="12" class="pb-3">
                  <v-text-field
                    v-model.trim="filter_search"
                    v-on:click:clear="clearFilter('search')"
                    clearable
                    dense
                    filled
                    flat
                    label="Type and press enter to search"
                    hide-details
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    color="cyan"
                    @keydown.enter="getVisits()"
                  ></v-text-field>
                </v-flex>
                <v-flex md="12" class="pb-3" v-if="false">
                  <label class="font-weight-600">Type </label>
                  <v-autocomplete
                    :items="optionsData"
                    v-model="filter_option"
                    dense
                    flat
                    filled
                    label="Options"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-value="value"
                    item-text="text"
                    class="filter-select"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title
                          v-html="'No Option(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item-action class="ma-0">
                        <v-chip
                          style="height: 10px; width: 10px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                        >
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-action class="mr-0">
                        <v-chip
                          style="height: 16px; width: 16px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.text }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <label class="font-weight-600">Visit #</label>
                  <v-text-field
                    v-model.trim="filter_visit_no"
                    v-on:click:clear="clearFilter('visit_no')"
                    clearable
                    dense
                    filled
                    flat
                    label="Search by Visit #"
                    hide-details
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    color="cyan"
                    @keydown.enter="getVisits()"
                  ></v-text-field>
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <label class="font-weight-600">Date Type </label>
                  <v-autocomplete
                    :items="dateFilters"
                    v-model="filter_date_type"
                    dense
                    flat
                    filled
                    label="Date Type"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-value="value"
                    item-text="text"
                    class="filter-select"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title
                          v-html="'No Date Type Found.'"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item-action class="ma-0">
                        <v-chip
                          style="height: 10px; width: 10px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                        >
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-action class="mr-0">
                        <v-chip
                          style="height: 16px; width: 16px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.text }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <div>
                    <label class="font-weight-600">Visit Date Range </label>
                    <DateRangePicker
                      placeholder="Date Range"
                      v-model="dates"
                      v-on:click:clear="clearFilter('dates')"
                      class="mr-2"
                    ></DateRangePicker>
                  </div>
                  <v-menu
                    v-if="false"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <label class="font-weight-600">Visit Date Range </label>
                      <v-text-field
                        dense
                        filled
                        flat
                        label="Visit Date Range"
                        hide-details
                        solo
                        :disabled="
                          pageLoading || customerLoading || statusLoading
                        "
                        :loading="
                          pageLoading || customerLoading || statusLoading
                        "
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-on:click:clear="clearFilter('dates')"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :value="formattedDate"
                        color="cyan"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="cyan"
                      range
                      :disabled="pageLoading"
                      v-model="dates"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <label class="font-weight-600">Visit Status</label>
                  <v-autocomplete
                    v-model.trim="filter_status"
                    :items="statusList"
                    dense
                    flat
                    filled
                    label="Visit Status"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-value="status"
                    item-text="text"
                    class="filter-select"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title
                          v-html="'No Status(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item-action class="ma-0">
                        <v-chip
                          style="height: 10px; width: 10px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                        >
                          <template v-if="item.value == 'all'"
                            >{{ item.text }} ({{
                              item.all_ticket_visits
                            }})</template
                          >
                          <template v-else
                            >{{ item.text }} ({{
                              item.ticket_visit_status_count
                            }})</template
                          >
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-action class="mr-0">
                        <v-chip
                          style="height: 16px; width: 16px; padding: 0"
                          :color="item.color"
                        >
                        </v-chip>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.text }}</v-list-item-title
                        >
                      </v-list-item-content>
                      <v-list-item-action
                        class="align-self-center common-listing-row:nth-child"
                      >
                        <v-list-item-subtitle
                          class="text-lowercase font-weight-500 font-size-14"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_ticket_visits
                          }}</template>
                          <template v-else>{{
                            item.ticket_visit_status_count
                          }}</template></v-list-item-subtitle
                        >
                      </v-list-item-action>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <label class="font-weight-600 ml-1">Job Type</label>
                  <v-autocomplete
                    clearable
                    v-on:click:clear="clearFilter('job_type')"
                    v-model.trim="filter_job_type"
                    :items="job_type"
                    dense
                    flat
                    filled
                    label="Job Type"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-value="text"
                    item-text="text"
                    class="mr-2"
                    multiple
                  >
                  </v-autocomplete>
                </v-flex>

                <v-flex v-if="!internal || engineerId" md="12" class="pb-3">
                  <label class="font-weight-600">Customer</label>
                  <customer-dropdown v-model.trim="filter_customer" />
                </v-flex>
                <v-flex md="12" class="pb-3">
                  <label class="font-weight-600">Site Location</label>
                  <property-dropdown
                    v-model.trim="filter_property"
                    :customer-id="filter_customer"
                    placeholder="Site Location"
                  />
                </v-flex>
                <v-flex md="12" class="pb-3" v-if="false">
                  <label class="font-weight-600">Zones</label>
                  <v-autocomplete
                    hide-details
                    clearable
                    v-model.trim="filter_zone"
                    :items="zones"
                    dense
                    flat
                    filled
                    label="Zones"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-text="name"
                    item-value="name"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title
                          v-html="'No Zone(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-icon class="mr-3">
                        <v-icon>mdi-home-map-marker</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content
                        class="text-ellipsis max-width-400px"
                      >
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md="12" class="pb-3" v-if="!internal">
                  <label class="font-weight-600">Technician</label>
                  <v-autocomplete
                    hide-details
                    clearable
                    v-model.trim="filter_engineer"
                    :items="engineerList"
                    dense
                    flat
                    filled
                    placeholder="Technician"
                    item-color="cyan"
                    color="cyan"
                    solo
                    :disabled="pageLoading || customerLoading || statusLoading"
                    :loading="pageLoading || customerLoading || statusLoading"
                    item-text="display_name"
                    item-value="id"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title
                          v-html="'No Technician(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar
                        height="30"
                        min-width="30"
                        width="30"
                        class="mr-1 my-1 grey lighten-2 grey--text"
                      >
                        <v-img
                          v-if="item.profile_logo != null"
                          src="item.profile_logo"
                        ></v-img>
                        <span v-else class="fw-600 mb-1">{{
                          item.display_name.slice(0, 2).toUpperCase()
                        }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content
                        class="text-ellipsis max-width-400px"
                      >
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.display_name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        class="align-self-center"
                        v-if="filter_engineer == item.id"
                      >
                        <v-icon color="cyan">mdi-check</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </div>
            </div>
          </perfect-scrollbar>
          <v-divider class="my-0"></v-divider>
          <div class="pa-5 d-flex mt-auto border-top-grey">
            <v-btn
              class="mr-2 custom-bold-button white--text"
              color="red"
              tile
              depressed
              :disabled="pageLoading || customerLoading || statusLoading"
              :loading="pageLoading || customerLoading || statusLoading"
              v-on:click="
                () => {
                  removeFilters();
                  isFilterDrawer = false;
                }
              "
            >
              <v-icon left>mdi-close</v-icon>
              <span>Clear Filter</span>
            </v-btn>
            <v-btn
              class="mr-2 custom-bold-button white--text"
              color="cyan"
              tile
              depressed
              :disabled="pageLoading || customerLoading || statusLoading"
              v-on:click="
                () => {
                  filterRow();
                  isFilterDrawer = false;
                }
              "
            >
              <v-icon left>mdi-magnify</v-icon>
              <span>Apply Filter</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-navigation-drawer>
    <VCard
      border
      class="pr-3 py-0 filter-enabled main-listing-page"
      v-if="isFilterApply() && !isFilterDrawer && !internal"
    >
      <div class="d-flex">
        <div class="d-flex">
          <div
            class="mr-1 px-2 font-weight-medium text-uppercase text-center"
            style="
              font-size: 15px;
              border-right: 1px solid #f7e3cd;
              background-color: #f7e3cd;
            "
          >
            Filtered<br />
            By
          </div>
          <div>
            <template v-if="filter_search">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_search')"
                >{{ filter_search }}
              </VChip>
            </template>
            <template v-if="dates && dates.length">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('dates')"
                ><!-- {{ dates.join(" ~ ") }} -->
                {{ dates.map((d) => formatDate(d)).join(" ~ ") }}</VChip
              >
            </template>

            <template v-if="filter_visit_no">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_visit_no')"
                >Visit # : {{ filter_visit_no }}
              </VChip>
            </template>

            <template v-if="filter_option">
              <VChip
                label
                class="ma-1 text-uppercase"
                close
                @click:close="() => removeFilters('filter_option')"
                >Type : {{ g_filter_option }}</VChip
              >
            </template>
            <template v-if="filter_date_type">
              <VChip
                label
                class="ma-1 text-uppercase"
                close
                @click:close="() => removeFilters('filter_date_type')"
                >Date Type : {{ g_filter_date_type }}</VChip
              >
            </template>
            <template v-if="filter_zone">
              <VChip
                label
                class="ma-1 text-uppercase"
                close
                @click:close="() => removeFilters('filter_zone')"
                >Zone : {{ g_filter_zone }}</VChip
              >
            </template>
            <template v-if="filter_status">
              <VChip
                label
                class="ma-1 text-uppercase"
                close
                @click:close="() => removeFilters('filter_status')"
                >Status : {{ g_filter_status }}</VChip
              >
            </template>
            <template v-if="filter_customer">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_customer')"
                >Customer : {{ g_filter_customer }}</VChip
              >
            </template>
            <template v-if="filter_property">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_property')"
                >Site : {{ g_filter_property }}</VChip
              >
            </template>
            <template v-if="filter_engineer">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_engineer')"
                >Technician : {{ g_filter_engineer }}</VChip
              >
            </template>
            <template v-if="filter_job_type && filter_job_type.length">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('filter_job_type')"
                >Job Type :{{ filter_job_type.join(" ~ ") }}</VChip
              >
            </template>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              size="small"
              v-bind="attrs"
              v-on="on"
              @click="removeFilters('all')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Remove Filter</span>
        </v-tooltip>
      </div>
    </VCard>
    <Dialog :common-dialog="assignDialog" :dialog-width="900">
      <template v-slot:title>
        Assign Technicians
        <template v-if="assignRow">
          - {{ assignRow.trip_barcode || assignRow.visit_barcode }}
        </template>
        <template v-if="assignRow && assignEngineerIds.length">
          ({{ assignEngineerIds.length }} selected)
        </template>
      </template>

      <template v-slot:body>
        <v-container fluid class="py-0">
          <v-row>
            <v-col md="12" class="pt-0 custom-listing-table">
              <div class="d-flex align-center">
                <v-text-field
                  style="max-width: 300px"
                  v-model.trim="assignSearch"
                  clearable
                  dense
                  filled
                  flat
                  placeholder="Search by name, designation, email or phone"
                  hide-details
                  solo
                  color="cyan"
                  class="mr-2"
                  :disabled="assignLoading || assignSaving"
                ></v-text-field>
                <v-autocomplete
                  v-model.trim="assignType"
                  :items="assignTypeList"
                  dense
                  filled
                  flat
                  solo
                  hide-details
                  color="cyan"
                  style="max-width: 180px"
                  placeholder="Type"
                  item-value="value"
                  item-text="text"
                  :disabled="assignLoading || assignSaving"
                  @change="onAssignTypeChange"
                ></v-autocomplete>
                <v-autocomplete
                  v-model.trim="assignRelatedText"
                  :items="assignSkillList"
                  dense
                  filled
                  flat
                  solo
                  clearable
                  hide-details
                  color="cyan"
                  class="ml-2"
                  style="max-width: 240px"
                  placeholder="Select Skill/Cert"
                  item-value="text"
                  item-text="text"
                  :disabled="assignLoading || assignSaving || assignType === 'all'"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>No Category(s) Found.</v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-action class="ma-0">
                      <v-chip
                        style="height: 16px; width: 16px; padding: 0"
                        :color="item.color"
                      ></v-chip>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="text-capitalize font-weight-500">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-action class="mr-0">
                      <v-chip
                        style="height: 16px; width: 16px; padding: 0"
                        :color="item.color"
                      ></v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize font-weight-500">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </div>
            </v-col>

            <v-col md="12" class="pt-0 custom-listing-table">
              <div v-if="assignLoading" class="py-10 text-center">
                <v-progress-circular indeterminate color="cyan"></v-progress-circular>
              </div>

              <v-simple-table v-else class="inner-simple-table" fixed-header>
                <template v-slot:default>
                  <thead style="background-color: rgb(243, 246, 249); color: rgb(36, 50, 109)">
                    <tr class="custom-border-bottom">
                      <td class="font-size-16 font-weight-700 p-0" width="15">
                        <v-checkbox
                          hide-details
                          color="cyan"
                          class="mt-0"
                          :input-value="assignAllSelected"
                          :indeterminate="assignSomeSelected"
                          :disabled="assignSaving || !assignFilteredItems.length"
                          @change="toggleAssignAll"
                        ></v-checkbox>
                      </td>
                      <td class="font-size-16 font-weight-700 p-0">Name</td>
                      <td class="font-size-16 font-weight-700 p-0">Role</td>
                      <td class="font-size-16 font-weight-700 p-0">Skills</td>
                      <td class="font-size-16 font-weight-700 p-0">Certificates</td>
                      <td class="font-size-16 font-weight-700 p-0">Licences</td>
                      <td class="font-size-16 font-weight-700 p-0">Contact Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="assignFilteredItems.length > 0">
                      <tr
                        v-for="(item, index) in assignFilteredItems"
                        :key="item.id"
                        :class="{ 'orange_lighten-5': index % 2 == 0 }"
                        style="cursor: pointer"
                        @click="toggleAssignRow(item.id)"
                      >
                        <td class="p-0" @click.stop>
                          <v-checkbox
                            hide-details
                            color="cyan"
                            class="mr-4 mt-0"
                            :input-value="assignSelected.has(item.id)"
                            :disabled="assignSaving || (item.disabled && !assignSelected.has(item.id))"
                            @change="toggleAssignRow(item.id)"
                          ></v-checkbox>
                        </td>

                        <td class="p-0">
                          <div class="d-flex">
                            <div class="mr-1">
                              <v-avatar size="35">
                                <v-img
                                  class="customer-image white-background"
                                  width="35"
                                  height="35"
                                  :lazy-src="$defaultProfileImage"
                                  :src="item.profile_logo ? item.profile_logo : $defaultProfileImage"
                                ></v-img>
                              </v-avatar>
                            </div>
                            <div>
                              <span class="font-weight-700 text-capitalize">{{ item.display_name }}</span>
                              <v-chip
                                v-if="item.disabled"
                                label
                                small
                                color="red"
                                class="text-white ml-1"
                                >Unavailable</v-chip
                              >
                              <div>
                                <v-chip
                                  v-if="item.designation_name"
                                  label
                                  color="red"
                                  small
                                  outlined
                                  style="font-size: 10px"
                                >
                                  {{ item.designation_name }}
                                </v-chip>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td class="p-0">
                          <span class="font-weight-700">{{ roleText(item) }}</span>
                        </td>

                        <td class="p-1">
                          <template v-if="item.all_skills && item.all_skills.length">
                            <v-chip
                              v-for="(skill, skillIndex) in item.all_skills"
                              :key="item.id + '-skill-' + skillIndex"
                              x-small
                              label
                              class="ma-1"
                              :color="skill.color || 'blue lighten-5'"
                              :text-color="skill.color ? undefined : 'blue darken-3'"
                            >
                              {{ skill.certificate_name || skill.name || skill.text }}
                            </v-chip>
                          </template>
                          <span v-else class="text-caption text--secondary">None</span>
                        </td>

                        <td class="p-1">
                          <template v-if="item.all_certificates && item.all_certificates.length">
                            <v-chip
                              v-for="(certificate, certificateIndex) in item.all_certificates"
                              :key="item.id + '-certificate-' + certificateIndex"
                              x-small
                              label
                              class="ma-1"
                              :color="certificate.color || 'purple lighten-5'"
                              :text-color="certificate.color ? undefined : 'purple darken-3'"
                            >
                              {{ certificate.certificate_name || certificate.name || certificate.text }}
                            </v-chip>
                          </template>
                          <span v-else class="text-caption text--secondary">None</span>
                        </td>

                        <td class="p-1">
                          <template v-if="item.all_licenses && item.all_licenses.length">
                            <v-chip
                              v-for="(license, licenseIndex) in item.all_licenses"
                              :key="item.id + '-license-' + licenseIndex"
                              x-small
                              label
                              class="ma-1"
                              :color="license.color || 'teal lighten-5'"
                              :text-color="license.color ? undefined : 'teal darken-3'"
                            >
                              {{ license.certificate_name || license.name || license.text }}
                            </v-chip>
                          </template>
                          <span v-else class="text-caption text--secondary">None</span>
                        </td>

                        <td class="p-0">
                          <div style="font-size: 13px">
                            <div class="d-flex align-center">
                              <v-icon size="15" color="cyan" class="mr-2">mdi-email-outline</v-icon>
                              <span v-if="item.email" style="word-break: break-all">{{ item.email }}</span>
                              <em v-else class="text-muted">no email</em>
                            </div>
                            <div class="d-flex align-center mt-1">
                              <v-icon size="15" color="cyan" class="mr-2">mdi-phone-outline</v-icon>
                              <span v-if="item.phone">{{ item.phone }}</span>
                              <em v-else class="text-muted">no phone</em>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="7">
                          <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                            Sorry! No Technician(s) Found.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          :disabled="assignSaving"
          v-on:click="closeAssign()"
        >
          Close
        </v-btn>
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          color="cyan white--text"
          :loading="assignSaving"
          :disabled="assignSaving || assignLoading || !assignChanged"
          v-on:click="saveAssign()"
        >
          Save
        </v-btn>
      </template>
    </Dialog>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { QUERY, DELETE, POST, GET } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import Priority from "@/view/pages/partials/Priority.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
import { find, isEmpty, toSafeInteger } from "lodash";
import JwtService from "@/core/services/jwt.service";
import { JobEventBus } from "@/core/lib/job/job.lib";
import draggable from "vuedraggable";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import DateRangePicker from "@/view/components/DateRangePicker.vue";
import CustomerDropdown from "@/view/components/Customer-Dropdown.vue";
import PropertyDropdown from "@/view/components/Property-Dropdown.vue";
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "visit-listing-template",
  mixins: [CommonMixin],

  props: {
    visitType: {
      type: String,
      required: true,
      default: "all",
    },
    detailRoute: {
      type: String,
      default: null,
    },
    detailType: {
      type: String,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isDeleted: {
      type: Boolean,
      default: false,
    },
    internal: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: 0,
    },
    propertyId: {
      type: Number,
      default: 0,
    },
    projectId: {
      type: Number,
      default: 0,
    },
    engineerId: {
      type: Number,
      default: 0,
    },
    teamId: {
      type: Number,
      default: 0,
    },
    contractId: {
      type: Number,
      default: 0,
    },
    quotationId: {
      type: Number,
      default: 0,
    },
    enquiryId: {
      type: Number,
      default: 0,
    },
    invoiceId: {
      type: Number,
      default: 0,
    },
    entityId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    detailRoute() {
      this.$emit("sccuess", true);
    },
    entityId() {
      this.initInternal();
    },
    customerId() {
      this.initInternal();
    },
    propertyId() {
      this.initInternal();
    },
    projectId() {
      this.initInternal();
    },
    engineerId() {
      this.initInternal();
    },
    teamId() {
      this.initInternal();
    },
    quotationId() {
      this.initInternal();
    },
    enquiryId() {
      this.initInternal();
    },

    invoiceId() {
      this.initInternal();
    },

    contractId: {
      handler() {
        this.initInternal();
      },
      immediate: true,
    },

    "$route.query"(newQuery) {
      if (!this.internal) {
        this.routeQuery = { ...newQuery };
      }
    },
  },
  components: {
    DeleteDialog,
    TableActivity,
    Priority,
    ListingFooter,
    draggable,
    ListingTable,
    DateRangePicker,
    PropertyDropdown,
    CustomerDropdown,
    Dialog,
  },
  data() {
    return {
      statusLoading: false,
      routeQuery: {},
      isFilter: false,
      uniqueId: Number(new Date()),
      isFilterDrawer: false,
      visitFilterTime: null,
      totalRows: 0,
      rowsOffset: 0,
      currentPage: 1,
      totalPages: 0,
      defaultColDefs: [],
      defaultColShow: [],
      customThead: [],
      zones: [],
      optionsData: [
        {
          text: "All",
          value: "all",
          color: "cyan",
        },
        {
          text: "Internal",
          value: "internal",
          color: "red",
        },
        {
          text: "External",
          value: "external",
          color: "green  ",
        },
      ],
      dateFilters: [
        { value: "appointment", text: "Appointment Date", color: "green" },
        { value: "actual_date", text: "Actual Date", color: "red" },
      ],
      selectedRows: [],
      perPage: 15,
      pageLoading: false,
      customerLoading: false,
      propertyLoading: false,
      engineerLoading: false,
      isRowLoading: {},
      filter_job_type: [],
      dates: [],
      statusList: [],
      engineerList: [],
      rowData: [],
      tags: [],
      job_type: [],
      filter_tag: [],
      /* filter_job_type: [], */
      filter_search: null,
      filter_customer: null,
      filter_option: null,
      filter_date_type: null,
      filter_engineer: null,
      filter_quotation: null,
      filter_contract: null,
      filter_invoice: null,
      filter_status: null,
      filter_team: null,
      filter_project: null,
      filter_zone: null,
      filter_property: null,
      timeout: null,
      timeoutLimit: 500,
      entity: 0,
      customer: 0,
      customerPerson: 0,
      customerProperty: 0,
      entityList: [],
      entityObject: {},
      deleteVisitId: null,
      deleteVisitDialog: false,
      deleteVisitLoading: false,
      deleteVisitBarcode: null,
      filter_visit_no: null,
      assignDialog: false,
      assignRow: null,
      assignEngineerIds: [],
      assignSearch: "",
      assignView: "all",
      assignType: "all",
      assignRelatedText: null,
      assignSkillList: [],
      assignTypeList: [
        { value: "all", text: "All" },
        { value: "skill", text: "Skill" },
        { value: "certificate", text: "Certificate" },
        { value: "license", text: "Licences" },
      ],
      assignLoading: false,
      assignSaving: false,
      assignEngineerList: [],
    };
  },
  mounted() {
    const _this = this;

    /*  this.$nextTick(async () => {
        this.statusList = await this.getStatusList();
      });
 */
    if (!this.internal) {
      const { query } = this.$route;
      // Set filters from query params if they exist
      this.currentPage =
        _this.lodash.toSafeInteger(_this.$route.query.page) || 1;
      this.dates = query.daterange ? query.daterange : [];

      this.filter_job_type = Array.isArray(query?.ticket_job_type)
        ? query.ticket_job_type.map(String)
        : query?.ticket_job_type
        ? String(query.ticket_job_type).split(",").map(String)
        : [];
      this.filter_search = query.search || "";
      this.filter_customer =
        _this.lodash.toSafeInteger(query.customer) || this.customerId;
      this.filter_engineer = _this.lodash.toSafeInteger(query.engineer) || null;
      this.filter_date_type = query.filter_date_type || null;
      this.filter_zone = query.zone || null;
      this.filter_property =
        _this.lodash.toSafeInteger(_this.$route.query.property) ||
        this.propertyId;
      this.filter_status = _this.lodash.toSafeInteger(query?.status) || null;
      this.filter_visit_no = query.visit_no || null;
      this.routeQuery = { ...this.$route.query };
    }

    _this.getVisits();
    PaginationEventBus.$on("update:pagination", (page) => {
      this.currentPage = Number(page);

      this.getVisits();
    });
  },
  methods: {
    filterRow() {
      this.isFilter = true;
      this.uniqueId = Number(new Date());
      /*  if(this.filter_status){
         this.$nextTick(async () => {
        this.statusList = await this.getStatusList();
      });
      } */
      this.getVisits();
    },
    openFilter() {
      this.pageLoading = true;
      this.initInternal();
      this.getEngineerList();
      this.get_job_type();
      this.$nextTick(async () => {
        this.statusList = await this.getStatusList();
      });
      this.pageLoading = false;
      this.isFilterDrawer = true;
    },
    columnLength() {
      const defaultColDefs = this.lodash.filter(this.defaultColDefs, {
        visible: true,
      });
      if (defaultColDefs) {
        return defaultColDefs.length;
      }
      return 0;
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    updateVisible() {
      const _this = this;

      for (let index = 0; index < _this.defaultColDefs.length; index++) {
        const element = _this.defaultColDefs[index];
        _this.defaultColDefs[index].visible = 0;
        if (_this.defaultColShow.includes(element.field)) {
          _this.defaultColDefs[index].visible = 1;
        }
      }

      _this.$nextTick(() => {
        _this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then(({ data }) => {
            this.customThead = data;
          });
      });
    },
    routeToDetail(row) {
      if (this.isDeleted) {
        return false;
      }
      this.$router.push(
        this.getDefaultRoute(this.detailRoute, {
          params: { id: row.visit_id },
        })
      );
    },

    openAssignDialog(row) {
      this.assignRow = row;
      this.assignSearch = "";
      this.assignView = "all";
      this.assignType = "all";
      this.assignRelatedText = null;
      this.assignSkillList = [];
      this.assignEngineerIds = (row.visit_engineers || []).map((e) => Number(e.id));
      this.assignEngineerList = [];
      this.assignDialog = true;
      this.loadAssignEngineers(row);
      this.getAssignRelatedSkill();
    },
    onAssignTypeChange() {
      this.assignRelatedText = null;
      this.getAssignRelatedSkill();
    },
    getAssignRelatedSkill() {
      if (this.assignType === "all") {
        this.assignSkillList = [];
        return;
      }
      this.$store
        .dispatch(GET, { url: `related-skill/${this.assignType}` })
        .then(({ data }) => {
          this.assignSkillList = Array.isArray(data) ? data : [];
        })
        .catch((error) => {
          this.assignSkillList = [];
          this.logError(error);
        });
    },
    loadAssignEngineers(row) {
      const fmt = (v, f) => (v && moment(v).isValid() ? moment(v).format(f) : "");
      const payload = {
        search: "",
        related_text: "",
        type: "",
        start_date: fmt(row.visit_started_at, "YYYY-MM-DD"),
        start_time: fmt(row.visit_started_at, "HH:mm"),
        end_date: fmt(row.visit_finished_at, "YYYY-MM-DD"),
        end_time: fmt(row.visit_finished_at, "HH:mm"),
        force: 0,
        customer: row.customer_id,
        property: row.property_id,
      };

      this.assignLoading = true;
      this.$store
        .dispatch(QUERY, { url: "ticket/available-engineers", data: payload })
        .then((res) => {
          const body = res?.data;
          const list = Array.isArray(body) ? body : body?.data ?? [];
          this.assignEngineerList = list.map(this.normalizeEngineer);
        })
        .catch((error) => {
          this.assignEngineerList = [];
          this.logError(error);
        })
        .finally(() => {
          this.assignLoading = false;
        });
    },
    normalizeEngineer(e) {
      return {
        id: Number(e.engineer_id),
        display_name: e.engineer_display_name,
        designation_name: e.engineer_designation,
        profile_logo: e.engineer_profile_logo,
        email: e.engineer_primary_email || null,
        phone: e.engineer_primary_phone || null,
        barcode: e.engineer_barcode,
        role: Number(e.engineer_role),
        disabled: Number(e.engineer_disabled) === 1,
        all_skills: Array.isArray(e.all_skills) ? e.all_skills : [],
        all_certificates: Array.isArray(e.all_certificates) ? e.all_certificates : [],
        all_licenses: Array.isArray(e.all_licenses) ? e.all_licenses : [],
      };
    },
    assignMatchesCertificateType(engineer, relatedText) {
      const target = String(relatedText || "").trim().toLowerCase();
      const matches = (items) =>
        Array.isArray(items) &&
        items.some((item) => {
          const name = String(
            (item && (item.certificate_name || item.name || item.text)) || ""
          ).toLowerCase();
          return name === target || name.includes(target);
        });

      if (this.assignType === "skill") return matches(engineer.all_skills);
      if (this.assignType === "certificate") return matches(engineer.all_certificates);
      if (this.assignType === "license") return matches(engineer.all_licenses);
      return (
        matches(engineer.all_skills) ||
        matches(engineer.all_certificates) ||
        matches(engineer.all_licenses)
      );
    },
    roleText(item) {
      const roles = {
        2: "Technician",
      };
      return roles[Number(item.role)] || "--";
    },
    closeAssign() {
      if (this.assignSaving) return;
      this.assignDialog = false;
      this.assignRow = null;
      this.assignEngineerIds = [];
      this.assignEngineerList = [];
    },
    toggleAssignRow(id) {
      if (this.assignSaving) return;
      const item = this.assignItems.find((e) => e.id === id);
      const ids = new Set(this.assignEngineerIds);
      // unavailable technicians can be removed but not newly added
      if (!ids.has(id) && item && item.disabled) return;
      if (ids.has(id)) ids.delete(id);
      else ids.add(id);
      this.assignEngineerIds = [...ids];
    },
    toggleAssignAll(checked) {
      if (this.assignSaving) return;
      const ids = new Set(this.assignEngineerIds);
      this.assignFilteredItems.forEach((e) => {
        if (checked) {
          if (!e.disabled) ids.add(e.id);
        } else {
          ids.delete(e.id);
        }
      });
      this.assignEngineerIds = [...ids];
    },
    saveAssign() {
      if (!this.assignRow || this.assignSaving || !this.assignChanged) return;
      this.assignSaving = true;
      const row = this.assignRow;
      const sel = this.assignSelected;
      const selected = this.assignItems.filter((e) => sel.has(e.id));

      this.$store
        .dispatch(POST, {
          url: `visit/${row.visit_id}/engineers`,
          data: { engineer_ids: this.assignEngineerIds },
        })
        .then(() => {
          this.$set(row, "visit_engineers", selected);
          this.assignSaving = false;
          this.closeAssign();
        })
        .catch((error) => {
          this.logError(error);
          this.assignSaving = false;
        });
    },
    priortyInteger(param) {
      return toSafeInteger(param);
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    formatetimedata(row) {
      //console.log(row,"row");
      return moment(row).format("hh:mm A");
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    deleteVisit({ visit_id, trip_barcode }) {
      this.deleteVisitId = visit_id;
      this.deleteVisitDialog = true;
      this.deleteVisitBarcode = trip_barcode;
    },
    exportVisit() {
      //console.log(this.searchableArray,"searchableArray");

      let downloadURL = process.env.VUE_APP_API_URL + "export/recurring-visits";
      let tab = this.$route.query.tab ?? "today";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      downloadURL.searchParams.append("search", tab);
      downloadURL.searchParams.append("filter[type]", tab);

      if (this.detailRoute == "all-job.detail") {
        downloadURL.searchParams.append("filter[job_type]", "all");
      } else {
        downloadURL.searchParams.append("filter[job_type]", "one-off");
      }

      //downloadURL.searchParams.append("search", this.queryParams.search);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });
      downloadURL.searchParams.append("export", true);

      const dateRange = this.dates || [];
      if (dateRange.length === 2) {
        downloadURL.searchParams.append("filter[daterange][0]", dateRange[0]);
        downloadURL.searchParams.append("filter[daterange][1]", dateRange[1]);
      }
      if (this.filter_date_type) {
        downloadURL.searchParams.append(
          "filter[filter_date_type]",
          this.filter_date_type
        );
      }
      if (this.filter_customer) {
        downloadURL.searchParams.append(
          "filter[customer]",
          this.filter_customer
        );
      }
      if (this.filter_engineer) {
        downloadURL.searchParams.append(
          "filter[engineer]",
          this.filter_engineer
        );
      }

      if (this.filter_status) {
        downloadURL.searchParams.append("filter[status]", this.filter_status);
      }

      if (this.filter_property) {
        downloadURL.searchParams.append(
          "filter[property]",
          this.filter_property
        );
      }
      if (this.filter_job_type && this.filter_job_type.length) {
        if (Array.isArray(this.filter_job_type)) {
          this.filter_job_type.forEach((type) => {
            downloadURL.searchParams.append("filter[ticket_job_type][]", type);
          });
        } else {
          downloadURL.searchParams.append(
            "filter[ticket_job_type]",
            this.filter_job_type
          );
        }
      }
      if (this.filter_search) {
        downloadURL.searchParams.append("filter[search]", this.filter_search);
      }
      if (this.filter_team) {
        downloadURL.searchParams.append("filter[team]", this.filter_team);
      }

      console.log(downloadURL);
      window.open(downloadURL, "_blank");
    },
    deleteVisitConfirm() {
      this.deleteVisitLoading = true;
      this.$store
        .dispatch(DELETE, { url: `visit/${this.deleteVisitId}` })
        .then(() => {
          this.deleteVisitId = null;
          this.deleteVisitDialog = false;
          this.deleteVisitBarcode = null;
          this.getVisits();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteVisitLoading = false;
        });
    },
    createJob() {
      this.$router.push(
        this.getDefaultRoute("job.create", {
          query: {
            type: "recurring",
          },
        })
      );

      /* if (!this.entity) {
          this.entityDialog = true;
        } else  if (!this.customer) {
          this.customerDialog = true;
        } else if (!this.customerProperty) {
          this.customerPropertyDialog = true;
        }*/
    },
    initInternal() {
      this.entity = this.lodash.toSafeInteger(this.entityId);
      this.customer = this.lodash.toSafeInteger(this.customerId);

      this.property = this.lodash.toSafeInteger(this.propertyId);
      this.filter_quotation = this.lodash.toSafeInteger(this.quotationId);
      this.filter_enquiry = this.lodash.toSafeInteger(this.enquiryId);
      this.filter_contract = this.lodash.toSafeInteger(this.contractId);
      this.filter_invoice = this.lodash.toSafeInteger(this.invoiceId);
      this.filter_engineer = this.lodash.toSafeInteger(this.engineerId);
      this.filter_team = this.lodash.toSafeInteger(this.teamId);
      this.filter_project = this.lodash.toSafeInteger(this.projectId);
      this.filter_property = this.property;
      this.filter_customer = this.customer;
      if (this.filter_team) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
          this.getEngineerList();
        });
      }
      if (this.filter_engineer) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
          this.getEngineerList();
        });
      }
      if (this.filter_project) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
          this.getEngineerList();
        });
      }
      if (this.filter_contract) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
          this.getEngineerList();
        });
      }
      if (this.entity && this.customer && this.filter_customer) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
          this.getEngineerList();
        });
      }
      if (this.filter_property) {
        this.$nextTick(async () => {
          this.getVisits();
          this.statusList = await this.getStatusList();
        });
      }
    },

    calculateTotalDuration(visit_date) {
      if (moment(visit_date).isValid()) {
        let a = moment(visit_date);
        let b = moment();

        let totalDuration = moment.duration(a.diff(b));
        if (b.isAfter(a)) {
          totalDuration = moment.duration(b.diff(a));
        }

        let result = [];

        let years = totalDuration.get("years");
        if (years > 0) {
          if (years == 1) {
            result.push(years + " Year");
          } else {
            result.push(years + " Years");
          }
        }

        let months = totalDuration.get("months");
        if (months > 0) {
          if (months == 1) {
            result.push(months + " Month");
          } else {
            result.push(months + " Months");
          }
        }

        let days = totalDuration.get("days");
        if (days > 0) {
          if (days == 1) {
            result.push(days + " Day");
          } else {
            result.push(days + " Days");
          }
        }

        let hours = totalDuration.get("hours");
        if (hours > 0) {
          if (hours == 1) {
            result.push(hours + " Hour");
          } else {
            result.push(hours + " Hours");
          }
        }

        let minutes = totalDuration.get("minutes");
        if (minutes > 0) {
          if (minutes == 1) {
            result.push(minutes + " Minute");
          } else {
            result.push(minutes + " Minutes");
          }
        }

        return result.join(" ");
      }
    },
    calculateActualTotalDuration(row) {
      if (moment(row.actual_start_date).isValid()) {
        let a = moment(row.actual_start_date);
        let b = moment(row.actual_end_date);

        let totalDuration = moment.duration(a.diff(b));
        if (b.isAfter(a)) {
          totalDuration = moment.duration(b.diff(a));
        }

        let result = [];

        let years = totalDuration.get("years");
        if (years > 0) {
          if (years == 1) {
            result.push(years + " Year");
          } else {
            result.push(years + " Years");
          }
        }

        let months = totalDuration.get("months");
        if (months > 0) {
          if (months == 1) {
            result.push(months + " Month");
          } else {
            result.push(months + " Months");
          }
        }

        let days = totalDuration.get("days");
        if (days > 0) {
          if (days == 1) {
            result.push(days + " Day");
          } else {
            result.push(days + " Days");
          }
        }

        let hours = totalDuration.get("hours");
        if (hours > 0) {
          if (hours == 1) {
            result.push(hours + " Hour");
          } else {
            result.push(hours + " Hours");
          }
        }

        let minutes = totalDuration.get("minutes");
        if (minutes > 0) {
          if (minutes == 1) {
            result.push(minutes + " Minute");
          } else {
            result.push(minutes + " Minutes");
          }
        }

        return result.join(" ");
      }
    },
    getEndDateTime(end) {
      return moment(end).format("DD MMMM YYYY hh:mm A");
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter_search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
        case "job_type":
          _this.filter_job_type = [];
          break;
        case "visit_no":
          _this.filter_visit_no = null;
          break;
      }
      _this.getVisits();
      this.isFilter = false;
    },
    removeFilters(type = "all") {
      const _this = this;
      if (type == "all") {
        _this.filter_search = null;
        _this.filter_visit_no = null;
        _this.dates = [];
        _this.filter_option = "";
        _this.filter_status = "";
        _this.filter_customer = "";
        _this.filter_property = "";
        _this.filter_zone = "";
        _this.filter_engineer = "";
        _this.filter_date_type = "";
        _this.filter_zone = "";
        _this.filter_job_type = [];
      } else if (type == "dates") {
        _this[type] = [];
      } else if (type == "filter_job_type") {
        _this[type] = [];
      } else {
        _this[type] = "";
      }

      _this.$nextTick(() => {
        _this.getVisits();
        _this.isFilter = false;
        _this.isFilterDrawer = false;
      });
    },
    isFilterApply() {
      let isFilter = false;
      if (
        this.filter_status ||
        this.filter_search ||
        this.filter_customer ||
        this.filter_visit_no ||
        this.filter_property ||
        this.filter_engineer ||
        this.filter_date_type ||
        this.filter_zone
      ) {
        isFilter = true;
      }
      if (this.filter_option && this.filter_option != "all") {
        isFilter = true;
      }
      if (this.filter_job_type && this.filter_job_type.length) {
        isFilter = true;
      }
      if (this.dates && this.dates.length) {
        isFilter = true;
      }
      return isFilter;
    },
    debounceFilter() {
      clearTimeout(this.visitFilterTime);
      this.visitFilterTime = setTimeout(() => {
        this.getVisits();
      }, 500);
    },
    getVisits() {
      const _this = this;

      if (_this.pageLoading) {
        return false;
      }

      let filter = {
        daterange: _this.dates,
        tags: _this.filter_tag,
        job_type: "recurring",
        ticket_job_type: _this.filter_job_type,
        entity: _this.entityObject ? _this.entityObject.id : undefined,
        search: _this.lodash.toString(_this.filter_search) || null,
        invoice: _this.lodash.toSafeInteger(_this.filter_invoice) || null,
        quotation: _this.lodash.toSafeInteger(_this.filter_quotation) || null,
        enquiry: _this.lodash.toSafeInteger(_this.filter_enquiry) || null,
        contract: _this.lodash.toSafeInteger(_this.filter_contract) || null,
        customer: _this.lodash.toSafeInteger(_this.filter_customer) || null,
        filter_option: _this.filter_option || null,
        filter_date_type: _this.filter_date_type || null,
        project: _this.lodash.toSafeInteger(_this.filter_project) || null,
        engineer: _this.lodash.toSafeInteger(_this.filter_engineer) || null,
        status: _this.lodash.toSafeInteger(_this.filter_status) || null,
        property: _this.lodash.toSafeInteger(_this.filter_property) || null,
        zone: this.filter_zone || null,
        team: _this.lodash.toSafeInteger(_this.filter_team) || null,
        type: _this.visitType,
        visit_no: _this.lodash.toString(_this.filter_visit_no) || null,
      };

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }

      _this.rowData = [];

      _this.pageLoading = true;
      _this.$emit("update-loading", _this.pageLoading);

      if (this.isFilter) {
        _this.currentPage = 1;
      }
      let current_page = _this.currentPage;
      let per_page = _this.perPage;
      // Construct the new query object
      let newQuery = {
        ...this.$route.query,
        ...filter,
        page: this.currentPage,
        current_page: this.currentPage,
      };

      // Remove empty/null/undefined values before pushing
      Object.keys(newQuery).forEach((key) => {
        const val = newQuery[key];
        if (
          val === null ||
          val === undefined ||
          val === "" ||
          val === [] ||
          (Array.isArray(val) && val.length === 0)
        ) {
          delete newQuery[key];
        }
      });

      // Compare current query with new query
      const isSameQuery = Object.keys(newQuery).every((key) => {
        return newQuery[key] === this.$route.query[key];
      });

      // Only push to router if the query has changed
      if (!isSameQuery && !this.internal) {
        this.$router.push({ query: newQuery });
      }

      _this
        .getVisitList({ filter, current_page, per_page })
        .then((data) => {
          /*   _this.rowData = data.rows;

            _this.totalPages = Math.ceil(data.total_rows / data.per_page);
            _this.currentPage = data.current_page;
            _this.totalRows = data.total_rows;
            _this.rowsOffset = data.offset; */
          _this.rowData = data.rows;
          _this.statusList = data.status_list;
          _this.totalPages = Math.ceil(data.total_rows / data.per_page);
          _this.currentPage = data.current_page;
          let thead = data.theads;
          _this.defaultColDefs = data.theads;
          _this.totalRows = data.total_rows;
          _this.customThead = [];
          for (let index = 0; index < thead.length; index++) {
            let element = thead[index];
            if (element.visible == 1) {
              _this.customThead.push(element);
            }
          }
          let t_out = this.lodash.filter(
            thead,
            (row) => Number(row.visible) == 1
          );
          _this.defaultColShow = this.lodash.map(t_out, "field");
          _this.rowsOffset = data.offset;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(async () => {
          /*  this.statusList = await this.getStatusList();
          this.getEngineerList(); */

          _this.pageLoading = false;
          _this.$emit("update-loading", _this.pageLoading);
        });
    },
    remove(item) {
      const index = this.tags.indexOf(item.id);
      this.tags.splice(index, 1);
    },
    checkStartTimeButton(rowData) {
      //console.log(rowData, "rowData");
      if (!isEmpty(rowData)) {
        let VisitAssignData = find(rowData, (row) => row.engineer_active == 1);

        if (VisitAssignData) {
          return "";
        } else {
          return "Unassigned";
        }
      }
    },

    engineerDisplayText(param) {
      const _this = this;
      let display_name = new Array();
      if (
        _this.lodash.isEmpty(param) === false &&
        _this.lodash.isArray(param)
      ) {
        display_name.push(param[0].display_name);
        if (param.length - 1) {
          const message = ` +${param.length - 1} more...`;
          display_name.push(message);
        }
      }
      if (_this.lodash.isEmpty(display_name)) {
        return "Not assigned.";
      } else {
        return display_name.join(", ");
      }
    },
    getVisitList(data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "all-recurring-jobs",
              data,
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDefaultPerson(defaultPerson) {
      if (this.lodash.isEmpty(defaultPerson)) {
        return "";
      }
      return defaultPerson.display_name;
    },
    getFormattedProperty(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }
      if (row.zip_code) {
        tempArr.push(row.zip_code);
      }
      return tempArr.join(", ");
    },
    get_tags() {
      this.loading = true;
      this.$store
        .dispatch(GET, { url: "tags/visit" })
        .then((response) => {
          this.tags = response?.data;
          this.$nextTick(() => {});
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    get_job_type() {
      this.loading = true;
      this.$store
        .dispatch(GET, { url: "setting/job" })
        .then((response) => {
          this.job_type = response?.data.job_type;
          this.zones = response?.data.zones;
          this.$nextTick(() => {});
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEngineers() {
      const _this = this;
      _this.engineerLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "engineer-list",
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              _this.engineerLoading = false;
              reject(error);
            })
            .finally(() => {
              _this.engineerLoading = false;
            });
        } catch (error) {
          _this.logError(error);
          _this.engineerLoading = false;
          reject(error);
        }
      });
    },
    getEngineerList() {
      const _this = this;

      _this
        .getEngineers()
        .then((engineer) => {
          _this.engineerList = engineer;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    getStatusList() {
      const _this = this;
      let filter = {
        daterange: _this.dates,
        entity: _this.entityObject ? _this.entityObject.id : undefined,
        search: _this.lodash.toString(_this.filter_search) || null,
        invoice: _this.lodash.toSafeInteger(_this.filter_invoice) || null,
        quotation: _this.lodash.toSafeInteger(_this.filter_quotation) || null,
        enquiry: _this.lodash.toSafeInteger(_this.filter_enquiry) || null,
        project: _this.lodash.toSafeInteger(_this.filter_project) || null,
        contract: _this.lodash.toSafeInteger(_this.filter_contract) || null,
        customer: _this.lodash.toSafeInteger(_this.filter_customer) || null,
        filter_option: _this.filter_option || null,
        filter_date_type: _this.filter_date_type || null,
        engineer: _this.lodash.toSafeInteger(_this.filter_engineer) || null,
        status: _this.lodash.toSafeInteger(_this.filter_status) || null,
        property: _this.lodash.toSafeInteger(_this.filter_property) || null,
        zone: _this.lodash.toSafeInteger(_this.filter_zone) || null,
        type: _this.visitType,
        job_type: "recurring",
        visit_no: _this.lodash.toString(_this.filter_visit_no) || null,
      };

      this.statusLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, { url: "visit/status", data: filter })
            .then((response) => {
              this.statusLoading = false;
              resolve(response.data);
            })
            .catch((error) => {
              this.statusLoading = false;
              reject(error);
            });
        } catch (error) {
          this.statusLoading = false;
          reject(error);
        }
      });
    },
    getReviewStatusColor(rating_status) {
      switch (rating_status) {
        case 1:
          return "cyan";
        case 2:
          return "orange";
        case 3:
          return "green";
        case 4:
          return "red";
        case 5:
          return "orange";
      }
    },
  },
  computed: {
    ...mapGetters(["vCustomerFilterList", "vPropertyFilterList"]),
    showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      let rowData = this.lodash.map(this.rowData, function (row) {
        if (!row.header) return row;
      });

      rowData = this.lodash.without(rowData, undefined);

      return this.rowsOffset + (rowData ? rowData.length : 0);
    },
    getFilterValue() {
      const filter = {};
      const filter_status =
        this.filter_option &&
        this.filter_option.find((row) => row.value == this.filter_status);
      filter.filter_status = filter_status.text;
      return filter;
    },
    g_filter_option() {
      const a =
        this.optionsData &&
        this.optionsData.find((row) => row.value == this.filter_option);
      return a?.text;
    },
    g_filter_date_type() {
      const a =
        this.dateFilters &&
        this.dateFilters.find((row) => row.value == this.filter_date_type);
      return a?.text;
    },
    g_filter_zone() {
      const a =
        this.zones && this.zones.find((row) => row.name == this.filter_zone);
      return a?.name;
    },
    g_filter_status() {
      /*   const a = this.statusList && this.statusList.find((row) => row.status == this.filter_status);
      return a?.text; */

      return this.getVisitStatusText(Number(this.filter_status));
    },
    g_filter_customer() {
      const a =
        this.vCustomerFilterList &&
        this.vCustomerFilterList.length > 0 &&
        this.vCustomerFilterList.find((row) => row.id == this.filter_customer);
      return a?.display_name;
    },
    g_filter_property() {
      const a =
        this.vPropertyFilterList &&
        this.vPropertyFilterList.find((row) => row.id == this.filter_property);
      return a?.barcode + "-" + a?.property_name;
    },
    g_filter_engineer() {
      const a =
        this.engineerList &&
        this.engineerList.find((row) => row.id == this.filter_engineer);
      return a?.display_name;
    },
    assignItems() {
  const map = new Map();
  (this.assignEngineerList || []).forEach((e) => map.set(e.id, e));
  ((this.assignRow && this.assignRow.visit_engineers) || []).forEach((e) => {
    const id = Number(e.id);
    const existing = map.get(id);
    if (!existing) {
      map.set(id, {
        ...e,
        id,
        role: e.role ?? e.engineer_role,
        disabled: false,
        all_skills: Array.isArray(e.all_skills) ? e.all_skills : [],
        all_certificates: Array.isArray(e.all_certificates) ? e.all_certificates : [],
        all_licenses: Array.isArray(e.all_licenses) ? e.all_licenses : [],
      });
    } else {
      map.set(id, {
        ...existing,
        email: existing.email || e.email,
        phone: existing.phone || e.phone,
        profile_logo: existing.profile_logo || e.profile_logo,
      });
    }
  });
  return Array.from(map.values());
    },
    assignSearchIndex() {
      return new Map(
        this.assignItems.map((e) => [
          e.id,
          [e.display_name, e.designation_name, this.roleText(e), e.email, e.phone, e.barcode]
            .filter(Boolean)
            .join(" ")
            .toLowerCase(),
        ])
      );
    },
    assignSelected() {
      return new Set(this.assignEngineerIds);
    },
    assignFilteredItems() {
      const q = (this.assignSearch || "").toLowerCase();
      const onlySelected = this.assignView === "selected";
      const sel = this.assignSelected;
      const index = this.assignSearchIndex;
      return this.assignItems.filter(
        (e) =>
          (!onlySelected || sel.has(e.id)) &&
          (!q || index.get(e.id).includes(q)) &&
          (!this.assignRelatedText ||
            this.assignMatchesCertificateType(e, this.assignRelatedText))
      );
    },
    assignAllSelected() {
      const sel = this.assignSelected;
      return (
        this.assignFilteredItems.length > 0 &&
        this.assignFilteredItems.every((e) => sel.has(e.id))
      );
    },
    assignSomeSelected() {
      const sel = this.assignSelected;
      return !this.assignAllSelected && this.assignFilteredItems.some((e) => sel.has(e.id));
    },
    assignChanged() {
      const original = (this.assignRow && this.assignRow.visit_engineers) || [];
      if (original.length !== this.assignEngineerIds.length) return true;
      const sel = this.assignSelected;
      return original.some((e) => !sel.has(Number(e.id)));
    },
  },
  beforeDestroy() {
    JobEventBus.$emit("show:visit", true);
    PaginationEventBus.$off("update:pagination");
    PaginationEventBus.$off("update:per-page");
  },
  created() {
    const _this = this;
    JobEventBus.$emit("show:visit", false);

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.currentPage = param;
      _this.getVisits();
    });

    PaginationEventBus.$on("update:per-page", (param) => {
      _this.perPage = param;
    });
  },
};
</script>
<style>
.filter-enabled {
  background-color: FDF0D1 !important;
  /*color: #57b965 !important; */
  position: fixed;
  bottom: 10px;
  left: 50%;
  max-width: 768px;
  min-width: 480px;
  transform: translateX(-50%);
  z-index: 9;
}

.v-window {
  overflow: initial !important;
}
</style>
